import "./bootstrap";

import { createApp, markRaw } from "vue";
import { createPinia } from "pinia";
import { init as sentryInit, createSentryPiniaPlugin } from "@sentry/vue";

import App from "./App.vue";
import "../css/app.css";

import router from "./router";
import i18n from "./i18n/index";

const app = createApp(App);

sentryInit({
  app,
  dsn: import.meta.env.VITE_SENTRY_DSN,
  environment: import.meta.env.MODE,
  enabled: import.meta.env.MODE !== "development",
  // Adds request headers and IP for users, for more info visit:
  // https://docs.sentry.io/platforms/javascript/guides/vue/configuration/options/#sendDefaultPii
  sendDefaultPii: true,
});

const pinia = createPinia();
pinia.use(createSentryPiniaPlugin());
pinia.use(({ store }) => {
  store.router = markRaw(router);
});

app.use(i18n);
app.use(pinia);
app.use(router);
app.mount("#app");
